<template v-bind:key="$route.path">
    <div class="wrapper" v-bind:key="$route.path">
        <div v-if="typeof page !== 'undefined'">
            <h1>{{ page.title }}</h1>
            <div v-html="page.richtext"></div>
        </div>
        <div class="notfound" v-if="typeof page == 'undefined'"><h1>404<br>Seite nicht gefunden</h1><img src="~@/assets/rocket.png"></div>
    </div>
</template>

<script>
    import axios from "axios"

    export default {
        data(){
            return {
                page: {}
            }
        },
        updated() {
            let vm = this
            let lang = this.$route.params.lang
            let page = this.$route.params.page

            axios({
                method: "post",
                data: {
                    query: `
                        query($page:[String], $lang:[String]) {
                            pages: entries(section: "pages", slug: $page, site: $lang){
                                id,
                                title,
                                ... on pages_pages_Entry {
                                    richtext
                                }
                            }
                        }
                    `,
                    variables: {
                        page,
                        lang
                    }
                }
            }).then(function(res){
                vm.page = res.data.data.pages[0]
            })
        },
        mounted() {
            let vm = this
            let lang = this.$route.params.lang
            let page = this.$route.params.page

            axios({
                method: "post",
                data: {
                    query: `
                        query($page:[String], $lang:[String]) {
                            pages: entries(section: "pages", slug: $page, site: $lang){
                                id,
                                title,
                                ... on pages_pages_Entry {
                                    richtext
                                }
                            }
                        }
                    `,
                    variables: {
                        page,
                        lang
                    }
                }
            }).then(function(res){
                vm.page = res.data.data.pages[0]
            })
        }
    }
</script>

<style scoped lang="scss">
    figure {
        width: 80%;
        margin: 0 auto;

        img {
            width: 100%;
        }
    }

    .notfound {
        text-align: center;
        margin-top: 20px;

        h1 {
            font-size: 58px;
        }

        img {
            width: 20vh;
            height: auto;
        }
    }
</style>
